import { cloneElement, ReactElement } from 'react';

import { Box, Popover, PopoverContent, PopoverProps, PopoverTrigger, Portal, StyleProps } from '@bonusly/design-system';

import { useIsTouchscreen } from '../../../../hooks/use-is-touchscreen';
import { ErrorBoundary } from '../../../error/error-boundary';
import { UserPopoverContent } from '../components/user-popover-content';

export enum ActionType {
	Recognize = 'recognize',
	ScheduleOneOnOne = 'scheduleOneOnOne',
	OpenOneOnOne = 'openOneOnOne',
}

export interface UserPopoverProps extends StyleProps {
	actionType?: ActionType;
	children: ReactElement;
	isDisabled?: boolean;
	name?: string; // this is for the avatar group overflow tooltip
	openDelay?: number;
	placement?: PopoverProps['placement'];
	source?: string; // source context for tracking
	userId: string;
}

export const UserPopover = ({ actionType, children, isDisabled, openDelay, placement, source, userId, ...rest }: UserPopoverProps) => {
	const isTouchscreen = useIsTouchscreen();
	const trigger = isTouchscreen ? 'click' : 'hover';

	return (
		<ErrorBoundary>
			<Popover isLazy isOpen={isDisabled ? false : undefined} openDelay={openDelay} placement={placement} trigger={trigger}>
				<PopoverTrigger>{cloneElement(children, rest)}</PopoverTrigger>

				<Portal>
					<Box
						sx={{
							'& .chakra-popover__popper': {
								zIndex: 'popover',
							},
						}}
					>
						<PopoverContent borderColor="bg.subtle" boxShadow="xl">
							<UserPopoverContent actionType={actionType} source={source} userId={userId} />
						</PopoverContent>
					</Box>
				</Portal>
			</Popover>
		</ErrorBoundary>
	);
};
